'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _dfpManager = require('../../../utils/ads/dfpManager');

var _dfpManager2 = _interopRequireDefault(_dfpManager);

var _breakPointMediator = require('../../../utils/breakpoint/breakPointMediator');

var _breakPointMediator2 = _interopRequireDefault(_breakPointMediator);

var _helpers = require('../../../utils/helpers');

var _AdWrapper = require('../AdWrapper');

var _AdWrapper2 = _interopRequireDefault(_AdWrapper);

var _DFPAd = require('./DFPAd.scss');

var _DFPAd2 = _interopRequireDefault(_DFPAd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * DFP Ad component
 * Allows these props: (sizeMapping, isSpecialAd, position, callback, refreshable)
 * @access public
 * @extends {React.Component}
 */
var DFPAd = function (_React$Component) {
  (0, _inherits3.default)(DFPAd, _React$Component);
  (0, _createClass3.default)(DFPAd, null, [{
    key: 'idGenerator',

    /**
     * Id randome generator
     * @returns {string} id
     */
    value: function idGenerator() {
      return 'div-gpt-ad-' + Math.floor(Math.random() * 10000);
    }
    /**
     * DFP ad generator
     * @param {Object} props React Props for this component
     * @constructor
     */

  }]);

  function DFPAd(props) {
    (0, _classCallCheck3.default)(this, DFPAd);

    /**
     * Setting of initial state for this component
     * @type {{id: null, device: string}}
     */
    var _this = (0, _possibleConstructorReturn3.default)(this, (DFPAd.__proto__ || (0, _getPrototypeOf2.default)(DFPAd)).call(this, props));

    _this.state = {
      id: null,
      device: ''
    };
    return _this;
  }
  /**
   * DFP ad generator
   */


  (0, _createClass3.default)(DFPAd, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var id = this.constructor.idGenerator();
      var device = _breakPointMediator2.default.getDevice();
      // Disabling to allow code on client only
      /* eslint-disable react/no-did-mount-set-state */
      this.setState({ id: id, device: device });
      if (this.hasValidProps(device)) {
        _dfpManager2.default.registerSlot((0, _extends3.default)({}, this.props, { slotID: id }));
      }
    }

    /**
     * Props validation helper
     * @param {string} device React Props for this component
     * @returns {boolean}
     */

  }, {
    key: 'hasValidProps',
    value: function hasValidProps(device) {
      return (0, _helpers.exists)(this.props.sizeMapping) && device !== '' && (0, _helpers.exists)(this.props.sizeMapping[device]);
    }

    /**
     * regular ad render
     * @returns {JSX}
     */

  }, {
    key: 'regularAd',
    value: function regularAd() {
      // just to avoid server client inconsistency
      var style = _DFPAd2.default.empty;
      var skeleton = void 0;
      var adMinWidth = 'auto';
      var adMinHeight = 'auto';

      if (this.hasValidProps(this.state.device)) {
        style = '';
        var size = this.props.sizeMapping[this.state.device][0];
        if ((0, _helpers.exists)(size) && size[1] > 0) {
          var _size = (0, _slicedToArray3.default)(size, 2);

          adMinWidth = _size[0];
          adMinHeight = _size[1];

          skeleton = _react2.default.createElement('div', {
            style: {
              width: size[0],
              height: size[1]
            },
            className: 'uvs-skeleton'
          });
        }
      }
      return _react2.default.createElement(
        _AdWrapper2.default,
        { className: style },
        _react2.default.createElement(
          'div',
          {
            id: this.state.id,
            style: {
              minWidth: adMinWidth,
              minHeight: adMinHeight
            }
          },
          skeleton
        )
      );
    }

    /**
     * special ad render
     * @returns {JSX}
     */

  }, {
    key: 'specialAd',
    value: function specialAd() {
      return _react2.default.createElement('div', { id: this.state.id, className: _DFPAd2.default.special });
    }

    /**
     * regular ad render
     * @returns {JSX}
     */

  }, {
    key: 'renderAd',
    value: function renderAd() {
      return this.props.isSpecialAd ? this.specialAd() : this.regularAd();
    }

    /**
     * On render it returns the ad
     * The children need to be wrapped in individual divs.
     * @returns {JSX}
     */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderAd()
      );
    }
  }]);
  return DFPAd;
}(_react2.default.Component);

/**
 * propTypes
 * @type {{sizeMapping: children property passed to this component, isSpecialAd: boolean}}
 */


exports.default = DFPAd;


/**
 * Default prop values
 * @type {{isSpecialAd: boolean}}
 */
DFPAd.defaultProps = {
  isSpecialAd: false
};


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/components/ads/dfp/DFPAd.js
// module id = 63
// module chunks = 35783957827783 71851226274881